export default "__VITE_ASSET__BQYY3U6t__"